import { z } from "zod"

import { tenantIdSchema } from "./identifiers.js"
import { platformSupportScopeV1Schema } from "./platform-workforce-v1.js"

const epochSchema = z.number().int().nonnegative().safe()

export const supportAccessAssertionClaimsV1Schema = z.object({
  version: z.literal(1),
  iss: z.literal("impetusos-platform-bff"),
  aud: z.string().regex(/^impetusos-frappe:[a-z0-9][a-z0-9.-]{2,253}$/),
  site: z.string().regex(/^[a-z0-9][a-z0-9.-]{2,253}$/),
  tenantId: tenantIdSchema,
  platformOperatorId: z.uuid(),
  supportAccessGrantId: z.uuid(),
  platformSupportCaseId: z.uuid(),
  purposeCode: z.string().regex(/^[a-z][a-z0-9_.-]{2,95}$/),
  scope: platformSupportScopeV1Schema,
  download: z.boolean(),
  commandId: z.uuid(),
  correlationId: z.uuid(),
  jti: z.uuid(),
  iat: epochSchema,
  exp: epochSchema,
}).strict().superRefine((claims, context) => {
  if (claims.aud !== `impetusos-frappe:${claims.site}`
      || claims.exp <= claims.iat || claims.exp - claims.iat > 30) {
    context.addIssue({
      code: "custom",
      path: ["exp"],
      message: "Support assertion must bind its site and a maximum 30-second lifetime.",
    })
  }
})

export const supportAccessAssertionProtectedHeaderV1Schema = z.object({
  alg: z.literal("HS256"),
  kid: z.enum(["a", "b"]),
  typ: z.literal("JWT"),
}).strict()

export type SupportAccessAssertionClaimsV1 = z.infer<
  typeof supportAccessAssertionClaimsV1Schema
>
